"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kazakhstanTranslations = void 0;
var _types = require("../../../types");
const kazakhstanTranslations = exports.kazakhstanTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Өкінішке орай!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Кейінгі бетке',
  [_types.ErrorPageTranslationKey.text]: 'Бұл парақша дәл казір жұмыс істемейді',
  [_types.ErrorPageTranslationKey.notFound]: 'Өкінішке орай, сіз еңгізген сайт мекенжайы жұмыс істемейді',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Сіз қол жеткізгіңіз келетін бетке шектеу қойылған және барлық талаптар орындалмаған.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Электрондық пошта арқылы Oriflame қолдау көрсету тобына хабарласыңыз:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Сұралған URL қабылданбады!'
};
